//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging"
import config from './config.json';
import { setEncryptLocalStorage } from './utils/global_functions';

// Your web app's Firebase configuration
const firebaseConfig = config.firebase;

const app = initializeApp(firebaseConfig)

const messaging = (async () => {
    try {
        const isSupportedBrowser = await isSupported();
        if (isSupportedBrowser) {
            return getMessaging(app)
        }
        console.log('Firebase does not support this browser')
        return null;
    } catch (error) {
        console.log(error)
        return null;
    }
})();

export const fetchToken = async (userId, handleToken) => {
    try {
        const messagingResolve = await messaging
        return await getToken(messagingResolve, { vapidKey: config.VAPID_KEY })
            .then((currentToken) => {
                if (currentToken) {
                    setEncryptLocalStorage(`FCM_TOKEN_${userId}`, currentToken)
                    handleToken()
                } else {
                    console.log("No registration token available. Request permission to generate one.");
                    new Notification('Permission required to show notifications')
                }
            })
            .catch((err) => {
                console.log("An error occurred while retrieving token. ", err);
            });
    } catch (error) {
        console.log("An error occurred while retrieving token. ", error);
    }

};

export const onMessageListener = async (handleMessage) => {
    try {
        const messagingResolve = await messaging;
        if (messagingResolve) {
            onMessage(messagingResolve, (payload) => {
                handleMessage(payload)
            })
        } else {
            console.log('Cannot listen FCM message')
        }
    } catch (error) {
        console.log(error)
    }

};
